import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  payments: 'Payments',
  inboundTickets: 'InboundTickets',
  bills: 'Bills',
  batchBills: 'BatchBills',
  settings: 'Settings',
  queuedPayments: 'QueuedPayments',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.payments, TAG_TYPES.queuedPayments],
  endpoints: {
    getPayments: {
      providesTags: result =>
        result && result.length > 0
          ? // successful query
            [
              ...result.map(payment => ({
                type: TAG_TYPES.payments,
                id: payment.id,
              })),
              { type: TAG_TYPES.payments, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'Payments', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.payments, id: 'LIST' }],
    },
    getPayment: {
      providesTags: (result, error, { paymentId }) => [{ type: TAG_TYPES.payments, id: paymentId }],
    },
    createPayment: {
      invalidatesTags: (result, error, { billId, batchBillId }) => [
        { type: TAG_TYPES.payments, id: 'LIST' },
        { type: TAG_TYPES.inboundTickets },
        ...(billId
          ? [
              { type: TAG_TYPES.bills, id: 'LIST' },
              { type: TAG_TYPES.bills, id: billId },
            ]
          : []),
        ...(batchBillId
          ? [
              { type: TAG_TYPES.batchBills, id: 'LIST' },
              { type: TAG_TYPES.batchBills, id: batchBillId },
            ]
          : []),
      ],
    },
    updatePayment: {
      invalidatesTags: (result, error, { paymentId }) => [
        { type: TAG_TYPES.payments, id: paymentId },
        { type: TAG_TYPES.inboundTickets },
        TAG_TYPES.settings,
      ],
    },
    voidPayment: {
      invalidatesTags: (result, error, { billId }) => [
        { type: TAG_TYPES.payments, id: 'LIST' },
        { type: TAG_TYPES.inboundTickets },
        { type: TAG_TYPES.bills, id: 'LIST' },
        { type: TAG_TYPES.bills, id: billId },
      ],
    },
    getInboundTicketQueuePayments: {
      providesTags: [{ type: TAG_TYPES.queuedPayments, id: 'LIST' }],
    },
  },
})

export const {
  useGetPaymentsQuery,
  useGetPaymentQuery,
  useCreatePaymentMutation,
  useUpdatePaymentMutation,
  useVoidPaymentMutation,
  useGetInboundTicketQueuePaymentsQuery,
} = api
